import { QuestionIcon } from '@/app/[locale]/_assets/icon-components'
import { AspectRatio, Box } from '@chakra-ui/react'
import useEmblaCarousel from 'embla-carousel-react'
import Image from 'next/image'
import React, { useCallback, useEffect, useState } from 'react'
import { Thumb } from './ThumbsButton'

const SliderDesktop = ({ list }: { list: string[] }) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const [emblaMainRef, emblaMainApi] = useEmblaCarousel()
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: 'keepSnaps',
    dragFree: true,
  })

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) return
      emblaMainApi.scrollTo(index)
    },
    [emblaMainApi, emblaThumbsApi]
  )

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return
    setSelectedIndex(emblaMainApi.selectedScrollSnap())
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap())
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex])

  useEffect(() => {
    if (!emblaMainApi) return
    onSelect()

    emblaMainApi.on('select', onSelect).on('reInit', onSelect)
  }, [emblaMainApi, onSelect])

  return (
    <section
      className="embla"
      style={{ '--slide-size': '100%' } as React.CSSProperties}
    >
      <div className="embla__viewport" ref={emblaMainRef}>
        <div className="embla__container">
          {list.map((item, index) => (
            <div className="embla__slide" key={index}>
              <AspectRatio
                display={'grid'}
                placeItems={'center'}
                position="relative"
                ratio={1 / 1}
                maxH={'500px'}
              >
                {item ? (
                  <Image
                    src={
                      item?.includes(process.env.BASE_URL!)
                        ? item
                        : process.env.BASE_URL + item
                    }
                    priority={true}
                    style={{
                      objectFit: 'cover',
                      borderRadius: '10px',
                    }}
                    loading="eager"
                    alt={'banner'}
                    fill
                  />
                ) : (
                  <Box>
                    <QuestionIcon />
                  </Box>
                )}
              </AspectRatio>
            </div>
          ))}
        </div>
      </div>
      {list?.length > 2 && (
        <div className="embla-thumbs">
          <div className="embla-thumbs__viewport" ref={emblaThumbsRef}>
            <div className="embla-thumbs__container">
              {list.map((item: string, index) => (
                <Thumb
                  item={item}
                  key={index}
                  onClick={() => onThumbClick(index)}
                  selected={index === selectedIndex}
                  index={index}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default SliderDesktop
